(function ($, drupalSettings, Drupal) {
})(jQuery, drupalSettings, Drupal);
(function ($, drupalSettings, Drupal) {
	Drupal.behaviors.cardListIcon = {
		attach: function (context) {
			$('.card-list-icon', context).click(function (e) {
				if ($(window).width() < Drupal.breakpoint.medium) {
					$(this).toggleClass('js-open');
					if ($(this).hasClass('js-open')) {
						$('.card-list-icon__copy', this).hide().slideDown(Drupal.eta, function () {
							$(this).removeAttr('style');
						});
					}
					else {
						$('.card-list-icon__copy', this).show().slideUp(Drupal.eta, function () {
							$(this).removeAttr('style');
						});
					}
				}
			});
		}
	};
})(jQuery, drupalSettings, Drupal);
(function ($, drupalSettings, Drupal) {
	Drupal.behaviors.cardQuestionsAnimate = {
		attach: function (context) {
			var $items = $('.card-text--question-right, .card-text--question-left', context);

			if ($items.length > 0) {
				var controller = new ScrollMagic.Controller();
				$items.each(function () {
					var $row = $(this);
					var right = $row.hasClass('card-text--question-right');
					var sceneOpts = {
						triggerElement: $row[0],
						triggerHook: "onEnter",
						duration: '100%',
						ease: Linear.easeNone,
						addIndicators: true,
					}

					// Question
					new ScrollMagic.Scene(sceneOpts)
						.setTween($('.card-text__symbol', $row)[0], { y: (right ? '100%' : '-90%') })
						.addTo(controller);
				});
			}
		}
	};
})(jQuery, drupalSettings, Drupal);
(function ($, drupalSettings, Drupal) {
	Drupal.behaviors.heroHomeHeader = {
		attach: function (context) {
			var $hero = $('.hero-home-header');
			if ($hero.length > 0) {
				var controller = new ScrollMagic.Controller();
				var sceneOpts = {
					triggerElement: $hero[0],
					triggerHook: "onLeave",
					duration: '100%',
					ease: Linear.easeNone,
				}

				// Triangle
				new ScrollMagic.Scene(sceneOpts)
					.setTween('.hero-home-header__icon--triangle', { y: '7%' })
					.addTo(controller);

				// Wrench
				new ScrollMagic.Scene(sceneOpts)
					.setTween('.hero-home-header__icon--wrench', { y: '100%' })
					.addTo(controller);

				// Rectangle
				new ScrollMagic.Scene(sceneOpts)
					.setTween('.hero-home-header__icon--rectangle', { y: '10%' })
					.addTo(controller);

				// Gear
				new ScrollMagic.Scene(sceneOpts)
					.setTween('.hero-home-header__icon--gear', { y: '-40%' })
					.addTo(controller);

				// Checkmark
				new ScrollMagic.Scene(sceneOpts)
					.setTween('.hero-home-header__icon--checkmark', { y: '-90%' })
					.addTo(controller);
			}
		}
	};

})(jQuery, drupalSettings, Drupal);
(function ($, drupalSettings, Drupal) {
	Drupal.behaviors.heroLogoSoup = {
		attach: function (context) {
			var $hero = $('.hero-logo-soup');
			if ($hero.length > 0) {
				var controller = new ScrollMagic.Controller();
				$hero.each(function () {
					var $row = $(this);
					var sceneOpts = {
						triggerElement: $row[0],
						triggerHook: "onEnter",
						duration: '100%',
						ease: Linear.easeNone,
					};

					// Move gear
					new ScrollMagic.Scene(sceneOpts)
						.setTween($('.hero-logo-soup__symbol', $row)[0], { y: '35%' })
						// .addIndicators(true)
						.addTo(controller);
				});
			}
		}
	};

})(jQuery, drupalSettings, Drupal);